import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans'
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormTitle from '../../../library/form/components/FormTitle'
import FormDialog from '../../../library/form/components/FormDialog';
import FormLabel from '../../../library/form/components/FormLabel';
import FormInput from '../../../library/form/components/FormInput';
import useRowSelector from "../../../library/hooks/selector/useRowSelector";

import InvImportItems from './InvImportItems'

const InvImportItemsHeader = (props) => {
    const { formObject, viewData, ...restProps } = props;

    const rowSelector = useRowSelector("2", null);

    if (!viewData)
        return (null)

    const imdtId = formObject.getFormData("importHeader", "", "fromDoc").val;  
    const imdocId = formObject.getFormData("importHeader", "", "fromDocId").val;

    console.log("import item", props);
    
    const importItemsVD =  {...viewData};
    delete importItemsVD.importHeader;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ actionId:"import", refreshMode:"dep", formActions: { forAction: "Confirm", forCancel: "Cancel" },actionParam:{is:2, viewCaller:"importDoc", selected:rowSelector.getSelectedRowsCS(),imdtId:imdtId, imdocId:imdocId, } }}
            formStyle={{ width: '750px' }}
            contentStyle={{ height: '400px' }}
            formTitle={<FormTitle formObject={formObject} value='Import Items' />}
            formObject={formObject} >
        <div>
            <ul className="uiImportItemsHeaderForm">
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="importHeader" action={{ paramName: "fromDoc" }} className="uiVal" value="From Doc" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="importHeader" action={{ paramName: "fromDoc" }} className='uiVal' />
                        <input type="hidden" />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="importHeader" action={{ paramName: "toDoc" }} value="To Doc" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="importHeader" action={{ paramName: "toDoc" }} className='uiVal' />
                    </div>
                </li>
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="importHeader" action={{ paramName: "fromDocId" }} value="From Doc ID / Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="importHeader" className="" 
                            action={{ InputType: "input", paramName: "fromDocId" }}
                        />
                        
                        <FormButton formObject={formObject} rowKey="importHeader" className="uiActionButton"
                            action={{ actionId: "import",  paramName: "getItem", 
                            actionParam: {imdtId:"#fromDoc", is:1, viewCaller:"importDoc", mode:"full", imdocId:"#fromDocId"} }}
                            text={<SarasTrans value="Get Items" />}>
                        </FormButton>
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="importHeader" action={{ paramName: "toDocId" }} className="uiVal" value="To Doc ID" />
                        </span>
                        <span id="vImpToDocId" ></span>
                        <FormROValue format="#" formObject={formObject} rowKey="importHeader" action={{ paramName: "toDocId" }} className='uiVal' />
                    </div>
                </li>
            </ul>
            <div id="importItemDtl">
                <div actionName="invcomp" className="action-name"></div>
                <div className="detailcontents">
                    <InvImportItems formObject={formObject} viewData={importItemsVD} rowSelector={rowSelector} />
                </div>
            </div>
        </div>
        </FormDialog>

    )
}

//TODO refresh the entire current composition
export default withView(InvImportItemsHeader, "invcomp", "invTrnHeader,itemDetail,invTrnFooter,invTrans,costbreakup,ccbreakup,qcSamplingList")